import axios from 'axios'
import { toastr } from 'react-redux-toastr'

import { URL } from '../../assets/js/constants'

function versaoLoading(data) {
    return {
        type: 'VERSAO_LOADING',
        payload: data
    }
}

function versaoProcessing(data) {
    return {
        type: 'VERSAO_PROCESSING',
        payload: data
    }
}

function carregarVersao(data) {
    return {
        type: 'VERSAO_FETCHED',
        payload: data
    }
}

function carregarVersoes(data) {
    return {
        type: 'VERSOES_FETCHED',
        payload: data
    }
}

export function getVersao(id) {
    return dispatch => {
        dispatch(versaoLoading(true));
        axios.get(`${URL}/app-versoes/${id}`)
            .then(resp => {
                dispatch(carregarVersao(resp.data));
                dispatch(versaoLoading(false));
            })
            .catch(e => {
                dispatch(versaoLoading(false));
                toastr.error('Erro', e.message);
            });
    }
}

export function getVersoes() {
    return dispatch => {
        dispatch(versaoLoading(true));
        axios.get(`${URL}/app-versoes`)
            .then(resp => {
                dispatch(carregarVersoes(resp.data));
                dispatch(versaoLoading(false));
            })
            .catch(e => {
                 dispatch(versaoLoading(false));
                toastr.error('Erro', e.message);
            });
    }
}

export function getUltimaVersao() {
    return dispatch => {
        dispatch(versaoLoading(true));
        axios.get(`${URL}/app-versoes/ultima-versao`)
            .then(resp => {
                dispatch(carregarVersao(resp.data));
                dispatch(versaoLoading(false));
            })
            .catch(e => {
                dispatch(versaoLoading(false));
                toastr.error('Erro', e.message);
            });
    }
}

export function addVersao(values) {
    return dispatch => {
        dispatch(versaoProcessing(true));
        axios.post(`${URL}/app-versoes`, values)
            .then(_ => {
                dispatch(getVersoes());
                dispatch(versaoProcessing(false));
                dispatch(toastr.success('Sucesso', 'Versão cadastrada com sucesso.'));
            })
            .catch(e => {
                try {
                    const data = e.response.data;
                    dispatch(versaoProcessing(false));
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}

export function atualizarVersao(values) {
    return dispatch => {
        dispatch(versaoProcessing(true));
        axios.put(`${URL}/app-versoes`, values)
            .then(_ => {
                dispatch(versaoProcessing(false));
                toastr.success('Sucesso', 'Versão atualizada!');
            })
            .catch(e => {
                dispatch(versaoProcessing(false));
                toastr.error('Erro inesperado', 'Não foi possível atualizar a versão. Tente novamente em alguns instantes.');
            })
    }
}

export function excluirVersao(id) {
    return dispatch => {
        dispatch(versaoProcessing(true));
        axios.delete(`${URL}/app-versoes/${id}`)
            .then(_ => {
                dispatch(getVersoes());
                dispatch(versaoProcessing(false));
                toastr.success('Sucesso', `Versão ${id} excluída com sucesso!`);
            })
            .catch(e => {
                dispatch(versaoProcessing(false));
                toastr.error('Erro inesperado', 'Não foi possível excluir a versão. Tente novamente em alguns instantes.');
            })
    }
}